import { action, createRequestTypes } from '../base';

export const dailyRunRateActionTypes = {
  GET_DAILY_RUN_RATES: createRequestTypes('GET_DAILY_RUN_RATES'),
  GET_DAILY_RUN_RATE_BY_ID: createRequestTypes('GET_DAILY_RUN_RATE_BY_ID'),
  CREATE_DAILY_RUN_RATE: createRequestTypes('CREATE_DAILY_RUN_RATE'),
  UPDATE_DAILY_RUN_RATE: createRequestTypes('UPDATE_DAILY_RUN_RATE'),
  DELETE_DAILY_RUN_RATE: createRequestTypes('DELETE_DAILY_RUN_RATE'),
  PIN_DAILY_RUN_RATE: createRequestTypes('PIN_DAILY_RUN_RATE'),
};

class DailyRunRateActions {

  getDailyRunRates = (payload, callback) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATES.REQUEST, {
    payload, callback,
  })

  getDailyRunRatesLoading = (getDailyRunRatesLoading) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATES.LOADING, {
    getDailyRunRatesLoading,
  })

  getDailyRunRatesSuccess = (dailyRunRates) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATES.SUCCESS, {
    dailyRunRates,
  })

  getDailyRunRateById = (payload, callback) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.REQUEST, {
    payload, callback,
  })

  getDailyRunRateByIdLoading = (getDailyRunRateByIdLoading) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.LOADING, {
    getDailyRunRateByIdLoading,
  })

  getDailyRunRateByIdSuccess = (selectedDailyRunRate) => action(dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.SUCCESS, {
    selectedDailyRunRate,
  })

  createDailyRunRate = (payload, callback) => action(dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.REQUEST, {
    payload,
    callback,
  })

  createDailyRunRateLoading = (createDailyRunRateLoading) => action(dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.LOADING, {
    createDailyRunRateLoading,
  })

  updateDailyRunRate = (payload, callback) => action(dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.REQUEST, {
    payload,
    callback,
  })

  updateDailyRunRateLoading = (updateDailyRunRateLoading) => action(dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.LOADING, {
    updateDailyRunRateLoading,
  })

  deleteDailyRunRate = (payload, callback) => action(dailyRunRateActionTypes.DELETE_DAILY_RUN_RATE.REQUEST, {
    payload,
    callback,
  })

  deleteDailyRunRateLoading = (deleteDailyRunRateLoading) => action(dailyRunRateActionTypes.DELETE_DAILY_RUN_RATE.LOADING, {
    deleteDailyRunRateLoading,
  })

  pinDailyRunRate = (payload, callback) => action(dailyRunRateActionTypes.PIN_DAILY_RUN_RATE.REQUEST, {
    payload,
    callback,
  })

  pinDailyRunRateLoading = (pinDailyRunRateLoading) => action(dailyRunRateActionTypes.PIN_DAILY_RUN_RATE.LOADING, {
    pinDailyRunRateLoading,
  })
}

export default new DailyRunRateActions();